import * as React from 'react';
import * as IPurchases from '../../../../../../interfaces/merchants/products/purchases';
import scrollToTop from '../../../../../hoc/scrollToTop';
import PurchaseItemList from '../../common/PurchaseItemList';
import PurchaseVerifyUserAlert from '../../common/PurchaseVerifyUserAlert';
import PurchaseCloseModalAlert from '../../common/texts/PurchaseCloseModalAlert';
import PurchaseCompleteAlert from '../../common/texts/PurchaseCompleteAlert';

import css from './index.module.scss';

interface Props {
  schemeType: IPurchases.SchemeType;
  product: IPurchases.MerchantProduct;
  settings: IPurchases.SettingCompletion;
  publicId: string;
}

const Completion: React.SFC<Props> = (props: Props) => {
  const {
    schemeType,
    product,
    settings: { expiryDate, verifiedUser },
    publicId,
  } = props;

  const labelType =
    schemeType === IPurchases.SchemeType.Subscription
      ? 'subscription'
      : 'ticketBook';
  return (
    <div className={css.Index}>
      <PurchaseCompleteAlert labelType={labelType} />
      {!verifiedUser && <PurchaseVerifyUserAlert labelType={labelType} />}
      <PurchaseItemList
        labelType={labelType}
        merchantImage={
          product.image ? product.image.thumb && product.image.thumb.url : ''
        }
        merchantName={product.name}
        merchantId={publicId}
        price={product.price}
        expiryDate={expiryDate}
      />
      <PurchaseCloseModalAlert labelType={labelType} />
    </div>
  );
};

export default scrollToTop(Completion);
